module.exports = __webpack_public_path__ + "img/Kh.fa0787d1.png";